var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import formatCharToSuperscript from '../../../../../helpers/formatCharToSuperscript';
import RewardsClients from '../../../../../const/clients';
import useRewards from '../../../../../hooks/useRewards';
import { Card, CardDescription, CardFooter, CardHeader, CardPoints, CardTitle } from './subcomponents';
var PropositionsCard = function (_a) {
    var dataCy = _a.dataCy, description = _a.description, heading = _a.heading, isFullWidthProposition = _a.isFullWidthProposition, points = _a.points;
    var t = useTranslation().t;
    var clientId = useRewards().clientId;
    var isWalgreensProduct = clientId === RewardsClients.walgreens;
    return (_jsxs(Card, __assign({ isFullWidthProposition: isFullWidthProposition, "data-cy": dataCy }, { children: [_jsxs(CardHeader, __assign({ "data-cy": "val-prop-card-header" }, { children: [_jsx(CardTitle, { children: heading }), _jsx(CardPoints, { children: points })] })), _jsx(CardDescription, __assign({ "data-cy": "val-prop-card-description" }, { children: formatCharToSuperscript(description, /(†)/, ['†']) })), isWalgreensProduct && (_jsx(CardFooter, __assign({ "data-cy": "val-prop-card-footer" }, { children: t('fullDetailsPage.exclusionsApply') })))] })));
};
export default PropositionsCard;
